import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'

interface RelatedReleasesProps {
  releases: string[]
}

export function RelatedReleases({ releases }: RelatedReleasesProps) {
  if (!releases || releases.length === 0) return null

  return (
    <div className="mt-6 p-4 rounded-lg bg-secondary/50 border border-border">
      <div className="flex items-start gap-3">
        <Sparkles className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">
          {releases.length === 1 ? (
            <>
              This feature was introduced in{' '}
              <Link
                to={`/changelog/${releases[0]}`}
                className="text-primary hover:underline font-medium"
              >
                {releases[0]}
              </Link>
              .
            </>
          ) : (
            <>
              Related releases:{' '}
              {releases.map((version, i) => (
                <span key={version}>
                  <Link
                    to={`/changelog/${version}`}
                    className="text-primary hover:underline font-medium"
                  >
                    {version}
                  </Link>
                  {i < releases.length - 1 ? ', ' : '.'}
                </span>
              ))}
            </>
          )}
        </p>
      </div>
    </div>
  )
}
